module.exports = __webpack_public_path__ + "static/image-01-6f654023cfaa6ab18b07a9422e2e68e8.jpg";